// extracted by mini-css-extract-plugin
export default {"title":"documents-modal_title__ZyFif","paragraph":"documents-modal_paragraph__vF5Xa"};